import { ReactNode } from 'react';
import LoginBotShadowIcon from 'assets/icons/login-shadow.svg';

import css from './LoginContainer.module.scss';

export const LoginContainer = ({ children }: { children: ReactNode }) => (
  <div className={css.loginPage}>
    <div className={css.loginPage__container}>{children}</div>
    <img
      alt="bot-shadow"
      className={css['loginPage__icon-shadow']}
      src={LoginBotShadowIcon}
    />
  </div>
);
